/**
 * Comprehensive permission definitions for granular access control
 * Permissions are organized by feature/domain
 */
export enum Permission {
  // Investigations
  INVESTIGATIONS_VIEW = 'investigations.view',
  INVESTIGATIONS_CREATE = 'investigations.create',
  INVESTIGATIONS_UPDATE_STATUS = 'investigations.updateStatus',
  INVESTIGATIONS_VIEW_MY = 'investigations.viewMy',

  // Events
  EVENTS_VIEW = 'events.view',
  EVENTS_VIEW_SOURCES = 'events.viewSources',
  EVENTS_VIEW_FACETS = 'events.viewFacets',

  // Users
  USERS_VIEW = 'users.view',
  USERS_CREATE = 'users.create',
  USERS_UPDATE = 'users.update',
  USERS_DELETE = 'users.delete',
  USERS_LOCK = 'users.lock',
  USERS_MANAGE_ROLES = 'users.manageRoles',

  // API Keys
  API_KEYS_VIEW = 'apiKeys.view',
  API_KEYS_CREATE = 'apiKeys.create',
  API_KEYS_DELETE = 'apiKeys.delete',

  // Assets
  ASSETS_VIEW = 'assets.view',
  ASSETS_CREATE = 'assets.create',
  ASSETS_UPDATE = 'assets.update',

  // Agents
  AGENTS_VIEW = 'agents.view',
  AGENTS_CREATE = 'agents.create',
  AGENTS_UPDATE = 'agents.update',
  AGENTS_DELETE = 'agents.delete',

  // Applications
  APPLICATIONS_VIEW = 'applications.view',
  APPLICATIONS_MANAGE = 'applications.manage',

  // Integrations
  INTEGRATIONS_VIEW = 'integrations.view',

  // Token Ledger
  TOKEN_LEDGER_VIEW = 'tokenLedger.view',

  // Operations Management
  OPS_MANAGEMENT_ACCESS = 'ops.access',
  COMPANIES_VIEW = 'companies.view',
  COMPANIES_MANAGE = 'companies.manage',
  TENANTS_VIEW = 'tenants.view',
  TENANTS_MANAGE = 'tenants.manage',
  TENANTS_ACTIVATE = 'tenants.activate',

  // Audit
  AUDIT_VIEW_ALL = 'audit.viewAll',
  AUDIT_VIEW_TENANT = 'audit.viewTenant',

  // Configurations
  CONFIG_VIEW = 'config.view',
  CONFIG_MANAGE = 'config.manage',
  CONFIG_TYPES_MANAGE = 'config.types.manage',

  // Agreements
  AGREEMENT_VIEW = 'agreement.view',
  AGREEMENT_ACCEPT = 'agreement.accept',

  // Trace Extraction Jobs
  TRACE_JOBS_VIEW = 'traceJobs.view',
  TRACE_JOBS_UPDATE = 'traceJobs.update',

  // Reports
  REPORTS_VIEW = 'reports.view',
}
